module.exports = __webpack_public_path__ + "img/3HONEY.7dd2b1ba.png";